import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from './toast/toast.component';
import { ToastService } from './toast.service';
import { ToastModule as SFToastModule } from '@syncfusion/ej2-angular-notifications';


@NgModule({
  declarations: [ToastComponent],
  imports: [
    CommonModule,
    SFToastModule,
  ],
  providers: [
    ToastService
  ],
  exports: [
    ToastComponent
  ]
})
export class ToastModule { }
